import type { KyInstance } from "ky";

import { getTodayTimeframe } from "./getTodayTimeframe";

export interface TodaySalesResponse {
    salesCount: number;
}

export const getTodaySales = async (client: KyInstance): Promise<TodaySalesResponse> => {
    const { start, end } = getTodayTimeframe();

    return await client.get("v1/metrics/sales", { retry: 0, searchParams: { start, end } }).json<TodaySalesResponse>();
};
